'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import ComplianceViolations from '../modals/nutrition/ComplianceViolations.react';
import MealCell from './MealCell.react';
import Popup from '@components/Widgets/Popup.react';
import { useMealPlanData, useUIState, usePermissions } from '../contexts';

import './MobileGrid.scss';
import { getStartTimeForMeal } from '@utils/Meals';

const MobileGrid = ({
    plan,
    maxOffset,
    mealTypes,
    hideViolations,
    profile
}) => {
    // Get context values from split contexts
    const { analysis } = useMealPlanData();
    const { hideWarnings } = useUIState();
    const { canViewNutrition } = usePermissions();

    const isAltPatient = profile.type === "alternate-patient";
    let showDailyViolations = !hideViolations && canViewNutrition;

    const offsets = [];

    for(var i = 0; i <= maxOffset; i++) {
        offsets.push(i);
    }

    return (
        <div className="mobile-grid">
            <div className="meal-types-column">
                {mealTypes.map(mealType => {
                    const startTime = getStartTimeForMeal(mealType.begin);
                    const endTime = getStartTimeForMeal(mealType.end);
                    return (
                        <div key={mealType.name} className="meal-types-row">
                            <div className="meal-details">
                                <span>{mealType.name}</span>
                                <span className="range">{startTime} - {endTime}</span>
                            </div>
                        </div>
                    )
                })}
            </div>

            <div className="meals-column-viewport">
                <div className="meals-column-container">
                    {offsets.map(offset =>(
                        <div key={offset} className="meals-column-cell">
                            <div className="day-offset-header">
                                Day {offset+1}

                                {showDailyViolations && analysis?.violationsByDay?.[offset]?.length > 0 && !isAltPatient && !hideWarnings ?
                                    <Popup button={<i className="icon-warning1" title="Click to see details" />}>
                                        <div>
                                            <ComplianceViolations mealType="Daily Totals"
                                                violations={analysis.violationsByDay[offset]} />
                                        </div>
                                    </Popup>
                                : null}
                            </div>

                            {mealTypes.map(mealType => (
                                <div key={mealType.name} className="meals-column-inner-container">
                                    <MealCell profile={profile} key={offset} offset={offset} mealType={mealType.name} plan={plan}
                                        meals={plan.items.filter(meal => meal.offset === offset && meal.meal === mealType.name)} />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

MobileGrid.propTypes = {
    plan: PropTypes.object.isRequired,
    maxOffset: PropTypes.number.isRequired,
    mealTypes: PropTypes.array.isRequired,
    hideViolations: PropTypes.bool,
    profile: PropTypes.object.isRequired,
};

export default MobileGrid;
